import { render } from "./plane-22.vue?vue&type=template&id=3f9858df&scoped=true"
import script from "./plane-22.vue?vue&type=script&lang=js"
export * from "./plane-22.vue?vue&type=script&lang=js"

import "./plane-22.vue?vue&type=style&index=0&id=3f9858df&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9858df"]])

export default __exports__